import React, { useContext } from 'react';

const ValidationContext = React.createContext({});
const { Provider: ValidationContextProvider, Consumer: ValidationContextConsumer } = ValidationContext;

const useValidationContext = () => useContext(ValidationContext);

export default ValidationContext;
export { ValidationContextProvider, ValidationContextConsumer, useValidationContext };
